import React, { useEffect, useState } from 'react';
import { Stack, Box } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { ContentLayout } from 'components/Layout';
import { MyAdsListView } from '../../components/MyAds/MyAdsListView';
import { BreadCrumbs } from 'components/Breadcrumbs';
import { paths } from 'routes';
import { useGetAll } from '../../api/getAll';
import { Loader } from 'components/Loader';
import { Add } from '../../components/Add';
import { useAuth } from 'lib/auth';
import { usePageSize } from 'hook/usePageSize';


export const List = () => {
  const [page, setPage] = useState(1);
  const [pageSize] = usePageSize();
  const [search, setSearch] = useState('');

  const { account } = useAuth();

  const {
    data: { jobAds, total },
    isFetching,
    refetch,
  } = useGetAll({
    search,
    page: page - 1,
    limit: pageSize,
    scope: account.super_admin ? 'all' : 'mine', // Fetch all for super admin, else 'mine'
    queryOptions: {},
  });

  const displayTotal = total;

  const debouncedSearchChange = useDebouncedCallback((val) => setSearch(val), 300);
  const handleSearchChange = ({ target: { value: val } }) => {
    debouncedSearchChange(val);
  };

  const handlePageChange = (_, newPage) => setPage(newPage);
  
  useEffect(() => {
    refetch();
  }, [page, pageSize, search, refetch]);
return (
  <ContentLayout>
    <Stack height={1}>
      <Stack
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: 2,
        }}
      >
        <BreadCrumbs
          items={[
            { name: '', to: paths.jobAds },
            { name: `Job Advertisements${displayTotal > 0 ? ` (${displayTotal})` : ''}` },
          ]}
        />
      </Stack>
      <Box sx={{ width: '100%' }}>
        {isFetching ? (
          <Loader />
        ) : (
          <MyAdsListView
            jobAds={jobAds}
            total={total}
            isFetching={isFetching}
            page={page}
            handleSearchChange={handleSearchChange}
            handlePageChange={handlePageChange}
            refetch={refetch}
            adminView
          />
        )}
      </Box>
    </Stack>
  </ContentLayout>
);
};
